import type { TagItem } from "src/queries/tags/tags.types";
import {
  MIN_SEARCH_LENGTH,
  TAGS_FAMILY_SEPARATOR,
} from "./AssetsFilterTags.constants";
import type { TagGroupingResult } from "./AssetsFilterTags.types";

export function filterRelevantTags(
  tags: TagItem[] | undefined,
  selectedTagIds: Set<number>,
  searchText: string,
  showSelectedOnly = false
): TagItem[] | undefined {
  if (!tags) return undefined;

  const shouldSearch = searchText.length >= MIN_SEARCH_LENGTH;
  const searchTextLower = searchText.toLowerCase();

  return tags.filter((t) => {
    const isRelevant = showSelectedOnly
      ? selectedTagIds.has(t.tag_id)
      : selectedTagIds.has(t.tag_id) || t.cnt > 0;
    const matchesSearch = shouldSearch
      ? t.name.toLowerCase().includes(searchTextLower)
      : true;

    return isRelevant && matchesSearch;
  });
}

export function groupTagsByFamily(
  relevantTags: TagItem[] | undefined
): TagGroupingResult {
  const familyMap = new Map<string, TagItem[]>();
  const standaloneTagsArray: TagItem[] = [];

  relevantTags?.forEach((t) => {
    if (t.name.includes(TAGS_FAMILY_SEPARATOR)) {
      const key = t.name.split(TAGS_FAMILY_SEPARATOR)[0];
      if (familyMap.has(key)) {
        familyMap.get(key)!.push(t);
      } else {
        familyMap.set(key, [t]);
      }
    } else {
      standaloneTagsArray.push(t);
    }
  });

  const familyNamesArray = Array.from(familyMap.keys()).sort();

  return {
    familyMap,
    standaloneTagsArray,
    familyNamesArray,
  };
}

export function calculateOpenFamilies(
  searchText: string,
  familyNames: string[],
  userCollapsed: Set<string>
): Set<string> {
  const shouldBeOpen = new Set<string>();
  familyNames.forEach((familyName) => {
    if (!userCollapsed.has(familyName)) {
      shouldBeOpen.add(familyName);
    }
  });
  return shouldBeOpen;
}

export function shouldUpdateOpenFamilies(
  prev: Set<string>,
  next: Set<string>
): boolean {
  if (prev.size !== next.size) return true;
  return !Array.from(next).every((name) => prev.has(name));
}
